// extracted by mini-css-extract-plugin
export default {"wrapper":"SortProductsFilter_wrapper__kRpbE","label":"SortProductsFilter_label__+pz1g"};